import Vuex from 'vuex';
import Vue from 'vue';
import axios from 'axios'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    animation: true,
    confettiMessage: '',
    customizations: {},
    dog: {},
    donations: [],
    ggApiUrl: process.env.VUE_APP_API_URL,
    ggLeaderboardsApiUrl: process.env.VUE_APP_LB_API_URL,
    ggStatsApiUrl: process.env.VUE_APP_STATS_API_URL || process.env.VUE_APP_API_URL,
    leaderboards: [],
    pusher: {
      cluster: process.env.VUE_APP_PUSHER_CLUSTER || 'us2',
      key: process.env.VUE_APP_PUSHER_KEY || '',
    },
    stats: {},
  },

  actions: {
    async addDonation({ commit }, donation) {
      commit('incrementTotalNumDonations');
      // We don't want to send the real donation ID in Pusher events, but v-for needs a unique key
      donation.id = Math.random().toString().substring(2)
      if (!donation.hide_amount){ commit('updateTotalAmountRaised', donation.intended_amount) }
      if (donation.online){ commit('updateDonations', donation) }
    },
    async loadCustomizations({ commit }) {
      const response = await axios.get(`${this.state.ggApiUrl}v1/dog_customizations?dog_id=${this.state.dog.id}&merge_defaults=true`)
      commit('setCustomizations', response.data);
    },
    async loadDog({ commit }) {
      const dogName = window.location.pathname.substring(1);
      const response = await axios.get(`${this.state.ggApiUrl}v1/giving_days/${dogName}`)
      commit('setDog', response.data);
    },
    async loadLeaderboards({ commit }) {
      const response = await axios.get(`${this.state.ggLeaderboardsApiUrl}v1/leaderboards?dog_id=${this.state.dog.id}&public_only=true`)
      commit('setLeaderboards', response.data);
    },
    async loadRecentDonations({ commit }) {
      const response = await axios.get(`${this.state.ggApiUrl}v1/donations`, {
        params: {
          dog_id: this.state.dog.id,
          per_page: 5,
          exclude_matches: true,
          donation_type: 'online',
          umbrella_donations: this.state.dog.id === this.state.dog.alpha_dog_id,
          use_new_search: true,
          with: 'group,group_logo,public_name',
        }
      });
      commit('setDonations', response.data.donations);
    },
    async loadStats({ commit }) {
      const controllerAction = this.state.customizations.umbrella_stats ? '/stats/umbrella_stats' : '/stats';

      const response = await axios.get(`${this.state.ggStatsApiUrl}v1/giving_days/${this.state.dog.id}${controllerAction}`)
      commit('setStats', response.data);
    },
    async statsUpdated({ commit }, stats) {
      commit('setStats', stats);
    },
    async setConfettiMessage({ commit }, message) {
      commit('setConfettiMessage', message);
    },
  },

  getters: {
    custom: (state) => (customizationName) => {
      return state.customizations[customizationName];
    },
    dogStat: (state) => (statName) => {
      // dog hasn't loaded when computed property in confetti mixin first runs, so
      // we need to check for frozen_stats presence to avoid accessing `statName` on `undefined`...
      const frozen = state.dog.frozen_stats?.[statName];
      if (frozen) {
        return parseInt(frozen.replace(/,/g, ''));
      } else {
        const stat = state.stats[statName];
        return stat && (statName === "total_amount_raised") ? Math.round(stat / 100) : stat;
      }
    },
  },

  mutations: {
    incrementTotalNumDonations: (state) => {
      state.stats.total_donations_count += 1;
    },
    setConfettiMessage: (state, message) => {
      state.confettiMessage = message;
    },
    setCustomizations: (state, customizations) => {
      state.customizations = customizations;
    },
    setDog: (state, dog) => {
      state.dog = dog;
    },
    setLeaderboards: (state, leaderboards) => {
      state.leaderboards = leaderboards;
    },
    setStats: (state, stats) => {
      state.stats = stats;
    },
    setDonations: (state, donations) => {
      state.donations = donations;
    },
    toggleAnimations: (state) => {
      state.animation = !state.animation;
    },
    updateDonations: (state, donation) => {
      state.donations.unshift(donation);
    },
    updateTotalAmountRaised: (state, donationAmount) => {
      state.stats.total_amount_raised += donationAmount;
    },
  }
});
